import { curry } from 'ramda';

const featureActionName = curry((feature, name) => `${feature}/${name}`);

export default featureActionName;
